module.exports = __webpack_public_path__ + "assets/img/icon_language_game.5c34e005.png";